// @ts-check

import {
  GET_API_TOKEN_LIST,
  DELETE_API_TOKEN_ACTION,
  CREATE_API_TOKEN_ACTION
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getApiTokensListStatus = state => state.status[getActionStatusName(GET_API_TOKEN_LIST)] || {};
export const deleteApiTokenStatus = state => state.status[getActionStatusName(DELETE_API_TOKEN_ACTION)] || {};
export const createApiTokenStatus = state => state.status[getActionStatusName(CREATE_API_TOKEN_ACTION)] || {};
